import { useEffect } from 'react'

import { getAuth, sendEmailVerification } from 'firebase/auth'
import { useAuthState } from 'react-firebase-hooks/auth'
import { Navigate, useNavigate } from 'react-router-dom'
import { Box, Button, Heading, Spinner } from '@chakra-ui/react'

import { useDeleteUser } from '@/react-query/user'
import { useDocumentTitle } from '@/views/hooks/useDocumentTitle'

const VerifyEmail = () => {
  useDocumentTitle('Verify email')
  const auth = getAuth()

  const deleteUser = useDeleteUser()
  const [user, isLoading] = useAuthState(auth)

  const navigate = useNavigate()

  if (isLoading) {
    return <Spinner className="m-auto w-10 h-10" />
  }

  if (!user) {
    return <Navigate to="/sign-in" replace />
  }

  if (user.emailVerified) {
    return <Navigate to="/home" replace />
  }

  useEffect(() => {
    if (user) {
      console.log('Start email verification interval')
      const intervalId = setInterval(async () => {
        await user.reload()
        const newUser = getAuth().currentUser
        console.log('New user', newUser)
        if (newUser?.emailVerified) {
          clearInterval(intervalId)
          navigate('/home')
        }
      }, 2000) // Check every 2 seconds

      return () => clearInterval(intervalId)
    }
  }, [])

  return (
    <main className="flex-1 flex flex-col justify-center items-center">
      <Heading size={'lg'} className="text-center">
        Verify email
      </Heading>
      <Box className="w-full max-w-md rounded-lg p-5">
        <Box>
          <Box>
            Welcome, {user.displayName}!<br />
            <br />
            Please click the link in the email we&apos;ve sent to{' '}
            <b>{user.email}</b> to complete sign-up by verifying your email.
          </Box>
          <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={'flex-start'}
          >
            <Button
              onClick={async () => {
                await sendEmailVerification(user, {
                  url: 'https://app.hirehire.ai/home',
                })
                console.log('Email verification sent')
              }}
              variant={'brand-solid-white'}
              mt={8}
            >
              Resend email
            </Button>
            <Button
              onClick={async () => {
                await deleteUser.mutateAsync()
              }}
              variant={'unstyled'}
              isLoading={deleteUser.isPending}
              fontSize={'xs'}
              textDecoration={'underline'}
              ml={2}
              mt={2}
              color={'blackAlpha.800'}
              h={'fit-content'}
            >
              Made a mistake? Delete and start over
            </Button>
          </Box>
        </Box>
      </Box>
    </main>
  )
}

export default VerifyEmail
